import { withTheme } from 'theme';
import { StatusBar } from './StatusBar';
var WTStatusBar = withTheme(StatusBar);
export default WTStatusBar;
//# sourceMappingURL=index.withTheme.js.map